/**
 * ServerNox — Biyometrik Onay Tercihleri ve Doğrulama Yardımcısı.
 * Mobil uygulamada (Android) kritik işlemler öncesinde parmak izi / yüz tanıma ile doğrulama yapılmasını sağlar.
 */

const STORAGE_KEY = 'servernox-biometric-confirm-enabled'

export function getBiometricConfirmationEnabled(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function setBiometricConfirmationEnabled(enabled: boolean): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false')
    window.dispatchEvent(new CustomEvent('servernox-biometric-pref-changed', { detail: { enabled } }))
  } catch {}
}

export async function getBiometricHardwareStatus(): Promise<{ available: boolean; hasEnrolled: boolean }> {
  if (typeof window === 'undefined') return { available: false, hasEnrolled: false }
  const scp = (window as any).SCPNative
  if (!scp?.isCapacitor || typeof scp.biometricAuthAvailable !== 'function') return { available: false, hasEnrolled: false }
  try {
    const res = await scp.biometricAuthAvailable()
    return { available: res?.available === true, hasEnrolled: res?.hasEnrolled === true }
  } catch {
    return { available: false, hasEnrolled: false }
  }
}

export async function isBiometricSupported(): Promise<boolean> {
  const status = await getBiometricHardwareStatus()
  return status.available
}

export async function verifyBiometricForAction(
  title: string = 'Kritik İşlem Onayı',
  description: string = 'Bu kritik işlemi gerçekleştirmek için parmak izinizi okutun.',
): Promise<{ success: boolean; cancelled?: boolean; message?: string; bypassed?: boolean }> {
  const enabled = getBiometricConfirmationEnabled()
  if (!enabled) {
    return { success: true }
  }

  const scp = (window as any).SCPNative
  if (!scp?.isCapacitor || typeof scp.performBiometricAuth !== 'function') {
    return { success: true }
  }

  // Cihazda donanım veya kayıtlı parmak izi yoksa engelleme yapma
  try {
    if (typeof scp.biometricAuthAvailable === 'function') {
      const avail = await scp.biometricAuthAvailable()
      if (!avail?.available) {
        return { success: true, bypassed: true }
      }
    }
  } catch {}

  return await scp.performBiometricAuth({
    title,
    subtitle: 'ServerNox Güvenlik Doğrulaması',
    description,
    negativeButtonText: 'İptal',
  })
}
